import Grid2 from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import styles from "./miniPlayerContent.module.css";

const MiniplayerSkeleton = () => (
  <Paper
    className={styles.paper_container_skeleton}
  >
    <Grid2 className={styles.main_grid}>
      <Grid2
        className={styles.skeleton_grid}
      >
        <Typography variant="subtitle1">
          <Skeleton width="60%" />
        </Typography>
        <Typography variant="subtitle1">
          <Skeleton width="80%" />
        </Typography>
      </Grid2>

      <Grid2 alignItems="center" container justifyContent="space-between">
        <Skeleton
          className={styles.skeleton_typography_grid}
          variant="rectangular"
          width="100%"
        />
        <Typography>
          <Skeleton width={40} />
        </Typography>
      </Grid2>
    </Grid2>
  </Paper>
);

export default MiniplayerSkeleton;